// extracted by mini-css-extract-plugin
module.exports = {"item":"HeldOrderTableRow_item__XlKAA","text":"HeldOrderTableRow_text__37Jll","center":"HeldOrderTableRow_center__uW1eO","row":"HeldOrderTableRow_row__2W9aQ"};